import * as turf from "@turf/turf";
import { LineString, Point } from "geojson";

export function determineSideAndDistance(target: Point, road: LineString) {
  const point = turf.point(target.coordinates);

  // Find the nearest point on the line
  const nearest = turf.nearestPointOnLine(road, point, {
    units: "meters",
  });
  var segmentIndex = nearest.properties.index; // Index of the segment

  // Get the segment points
  const coords = road.coordinates;
  const A = coords[segmentIndex];
  const B = coords[segmentIndex + 1];

  if (B == null) return;

  // Compute vectors
  const ABx = B[0] - A[0]; // Longitude difference
  const ABy = B[1] - A[1]; // Latitude difference
  const APx = target.coordinates[0] - A[0];
  const APy = target.coordinates[1] - A[1];

  // Cross product
  const cross = ABx * APy - ABy * APx;

  return {
    side: cross > 0 ? "left" : "right",
    distance: nearest.properties.dist,
  } as { side: "left" | "right"; distance: number };
}
